import React from 'react';
import { motion } from 'framer-motion';
import { faUser, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ShortenText from './utils/ShortenText';
import ToText from './utils/Totext';

const shortMonthName = new Intl.DateTimeFormat('en-US', { month: 'short' }).format;

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
  transition: { duration: 0.5 },
};

const MediumCard = ({ title, link, thumbnail, author, pubDate, content }) => {
  const date = new Date(pubDate);
  const publishDate = `${shortMonthName(date)} ${date.getDate()}, ${date.getFullYear()}`;

  return (
    <motion.a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="blog-card"
      {...fadeUp}
      whileHover={{ y: -6, scale: 1.02 }}
    >
      {thumbnail && (
        <div className="blog-card-image" style={{ backgroundImage: `url(${thumbnail})` }} />
      )}
      <div className="blog-card-body">
        <h3 className="blog-card-title">{ShortenText(title, 0, 60)}</h3>
        <p className="blog-card-excerpt">{ShortenText(ToText(content), 0, 120)}...</p>
        <div className="blog-card-meta">
          <span><FontAwesomeIcon icon={faUser} /> {author}</span>
          <span><FontAwesomeIcon icon={faCalendarAlt} /> {publishDate}</span>
        </div>
      </div>
    </motion.a>
  );
};

export default MediumCard;
